<template lang="pug">

div

    .ui.field

        //- Telefonnummer und Kurzwahl
        .two.fields
            //- Telefonnumer
            text-field(label='Allgemeine Telefonnummer' v-model='telephoneGeneral')
                field-error(v-bind:validation='validation' attribute='telephoneGeneral')

            //- Kurzwahl
            text-field(label='Kurzwahl' v-model='telephoneDirect')
                field-error(v-bind:validation='validation' attribute='telephoneDirect')

        //- Faxnummer und E-Email
        .two.fields
            //- Faxnummer
            text-field(label='Allgemeine Faxnummer' v-model='fax')
                field-error(v-bind:validation='validation' attribute='fax')

            //- E-Mail
            text-field(label='Allgemeine E-Mail-Adresse' v-model='email')
                field-error(v-bind:validation='validation' attribute='email')

    //- Bemerkung
    .field
        label(for='notice') Bemerkung
        textarea#notice(v-model='notice')

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import FieldError from '@/components/form/SmartFieldError'
    import TextField from '@/components/form/TextField'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { FieldError, TextField },

        computed: {

            email: {
                get() { return this.value.email },
                set(value) { this.updateValue('email', value) }
            },

            fax: {
                get() { return this.value.fax },
                set(value) { this.updateValue('fax', value) }
            },

            notice: {
                get() { return this.value.notice },
                set(value) { this.updateValue('notice', value) }
            },

            telephoneDirect: {
                get() { return this.value.telephoneDirect },
                set(value) { this.updateValue('telephoneDirect', value) }
            },

            telephoneGeneral: {
                get() { return this.value.telephoneGeneral },
                set(value) { this.updateValue('telephoneGeneral', value) }
            }

        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            },

        },

        validators: {

            fax(value) {
                return Validator.value(R.defaultTo('', value))
                    .regex(/^[+\d\s()/-]*$/, 'Ungültige Faxnummer')
            },

            telephoneDirect(value) {
                return Validator.value(R.defaultTo('', value))
                    .regex(/^[+\d\s()/-]*$/, 'Ungültige Telefonnummer')
            },

            telephoneGeneral(value) {
                return Validator.value(R.defaultTo('', value))
                    .regex(/^[+\d\s()/-]*$/, 'Ungültige Telefonnummer')
            },

            email(value) {
                return Validator.value(R.defaultTo('', value))
                    .email('Ungültige E-Mail-Adresse')
            }

        },

        props: {
            value: {
                type: Object,
                required: true
            }
        }

    }

</script>
